import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Zap, Search, Smartphone } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-center items-center text-center px-4 pt-32 pb-20"
    >
      {/* Background */}
      <div 
        className="absolute inset-0 z-0 bg-black"
        style={{
          backgroundImage: "url('/images/hero-bg.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto">
        {/* Gold Overline */}
        <div className="flex items-center justify-center mb-8">
          <div className="h-px w-12 bg-[#B8860B]"></div>
          <span className="mx-4 text-[#B8860B] text-xs tracking-[0.3em] uppercase">ALKA</span>
          <div className="h-px w-12 bg-[#B8860B]"></div>
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-headline"
          className="font-outfit text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light text-white tracking-tight leading-tight mb-6"
        >
          {t('hero.headline')}
        </h1>

        {/* Subheadline */}
        <p
          data-testid="hero-subheadline"
          className="text-lg sm:text-xl text-[#A1A1AA] font-light max-w-2xl mx-auto mb-10"
        >
          {t('hero.subheadline')}
        </p>

        {/* Key Points */}
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          <div className="flex items-center space-x-2 text-sm text-white/80">
            <Zap size={18} className="text-[#B8860B]" />
            <span>{t('hero.fastDelivery')}</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-white/80">
            <Search size={18} className="text-[#B8860B]" />
            <span>{t('hero.seoOptimized')}</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-white/80">
            <Smartphone size={18} className="text-[#B8860B]" />
            <span>{t('hero.mobileFirst')}</span>
          </div>
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToContact}
            className="bg-[#B8860B] hover:bg-[#9A7209] text-black px-10 py-4 rounded-full text-sm tracking-wide transition-all duration-300 w-full sm:w-auto font-medium"
            data-testid="hero-cta-website"
          >
            {t('hero.getWebsite')}
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-[#B8860B] rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
